import { Injectable } from '@angular/core';
import { LoadingService } from '@corteva-research/ngx-components-compat';
import { Observable } from 'rxjs/observable';

@Injectable()
export class LoadingWrapperService {
    constructor(private loadingService: LoadingService) { }

    setMessage(message: string){
        //setTimeout(() => this.loadingService.setMessage(message), 100);
        this.loadingService.setMessage(message);
    }

    clearMessage(){
        //setTimeout(() => this.loadingService.clearMessage(), 200);
        this.loadingService.clearMessage();
    }

    onMessageChange(): Observable<string>{
        let obs = null;
        setTimeout(() => obs = this.loadingService.onMessageUpdate(), 100);
        return obs;
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/loading-wrapper.service.ts